import { render, staticRenderFns } from "./AdminAnswer_edit_2.vue?vue&type=template&id=3fd97daa&"
import script from "./AdminAnswer_edit_2.vue?vue&type=script&lang=js&"
export * from "./AdminAnswer_edit_2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports